/**
 * App pageHead Object
 *
 * @type object
 */
App.pageHead = {

    /**
     * Constructor Function
     *
     * Boot function
     */
    init: function() {

    },


    /**
     * Get breadcrumb height
     *
     * @returns {*|jQuery}
     */
    getHeight: function() {
        return $('#page-head').outerHeight();
    },


    /**
     * Set breadcrumb height
     */
    setHeight: function() {

    }
};